import {
  FETCH_POST_AUTH_NOTIFICATIONS,
  FETCH_POST_AUTH_NOTIFICATIONS_FAILURE,
  FETCH_POST_AUTH_NOTIFICATIONS_SUCCESS,
  RESET_POST_AUTH_NOTIFICATIONS,
  SET_DESKTOP_NOTIFICATIONS_MODAL_OPEN,
  SET_NOTIFICATIONS_MODAL_AUTO_OPENED_LOANS,
  SET_PRE_AUTH_NOTIFICATIONS,
} from './constants';

export function fetchPostAuthNotifications() {
  return { type: FETCH_POST_AUTH_NOTIFICATIONS };
}

export function fetchPostAuthNotificationsFailure(error) {
  return {
    payload: { error },
    type: FETCH_POST_AUTH_NOTIFICATIONS_FAILURE,
  };
}

export function fetchPostAuthNotificationsSuccess(notifications, notificationsModalAutoOpened) {
  return {
    payload: { notifications, notificationsModalAutoOpened },
    type: FETCH_POST_AUTH_NOTIFICATIONS_SUCCESS,
  };
}

export function resetPostAuthNotifications() {
  return { type: RESET_POST_AUTH_NOTIFICATIONS };
}

export function setDesktopNotificationsModalOpen(value) {
  return {
    payload: { value },
    type: SET_DESKTOP_NOTIFICATIONS_MODAL_OPEN,
  };
}

export function setNotificationsModalAutoOpenedLoans(loanNumber) {
  return {
    payload: { loanNumber },
    type: SET_NOTIFICATIONS_MODAL_AUTO_OPENED_LOANS,
  };
}

export function setPreAuthNotifications(preAuthNotifications) {
  return {
    payload: { preAuthNotifications },
    type: SET_PRE_AUTH_NOTIFICATIONS,
  };
}
